/* parser generated by jison 0.4.18 */
/*
  Returns a Parser object of the following structure:

  Parser: {
    yy: {}
  }

  Parser.prototype: {
    yy: {},
    trace: function(),
    symbols_: {associative list: name ==> number},
    terminals_: {associative list: number ==> name},
    productions_: [...],
    performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate, $$, _$),
    table: [...],
    defaultActions: {...},
    parseError: function(str, hash),
    parse: function(input),

    lexer: {
        EOF: 1,
        parseError: function(str, hash),
        setInput: function(input),
        input: function(),
        unput: function(str),
        more: function(),
        less: function(n),
        pastInput: function(),
        upcomingInput: function(),
        showPosition: function(),
        test_match: function(regex_match_array, rule_index),
        next: function(),
        lex: function(),
        begin: function(condition),
        popState: function(),
        _currentRules: function(),
        topState: function(),
        pushState: function(condition),

        options: {
            ranges: boolean           (optional: true ==> token location info will include a .range[] member)
            flex: boolean             (optional: true ==> flex-like lexing behaviour where the rules are tested exhaustively to find the longest match)
            backtrack_lexer: boolean  (optional: true ==> lexer regexes are tested in order and for each matching regex the action code is invoked; the lexer terminates the scan when a token is returned by the action code)
        },

        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START),
        rules: [...],
        conditions: {associative list: name ==> set},
    }
  }


  token location info (@$, _$, etc.): {
    first_line: n,
    last_line: n,
    first_column: n,
    last_column: n,
    range: [start_number, end_number]       (where the numbers are indexes into the input string, regular zero-based)
  }


  the parseError function receives a 'hash' object with these members for lexer and parser errors: {
    text:        (matched text)
    token:       (the produced terminal token, if any)
    line:        (yylineno)
  }
  while parser (grammar) errors will also provide these members, i.e. parser errors deliver a superset of attributes: {
    loc:         (yylloc)
    expected:    (string describing the set of expected tokens)
    recoverable: (boolean: TRUE when the parser has a error recovery rule available for this particular error)
  }
*/
var c3dgrammar = (function(){
var o=function(k,v,o,l){for(o=o||{},l=k.length;l--;o[k[l]]=v);return o},$V0=[1,8],$V1=[27,37],$V2=[1,19],$V3=[1,25],$V4=[34,35],$V5=[32,37],$V6=[30,32],$V7=[1,52],$V8=[1,50],$V9=[1,51],$Va=[13,40,45,48,53,54],$Vb=[2,26],$Vc=[1,67],$Vd=[1,66],$Ve=[1,81],$Vf=[1,79],$Vg=[1,80],$Vh=[1,82],$Vi=[1,83],$Vj=[4,5,6,7,8,9,10,11,18,19,34],$Vk=[1,97],$Vl=[1,98],$Vm=[1,99],$Vn=[1,100],$Vo=[1,101],$Vp=[1,102],$Vq=[1,103],$Vr=[1,104],$Vs=[1,106],$Vt=[1,107],$Vu=[1,109],$Vv=[1,108],$Vw=[1,121],$Vx=[1,120],$Vy=[5,13,14,20,21],$Vz=[13,45,48,53,54];
var parser = {trace: function trace () { },
yy: {},
symbols_: {"error":2,"SIGNO":3,"+":4,"-":5,"*":6,"/":7,"=":8,"!":9,"<":10,">":11,"VALOR":12,"id":13,"number":14,"[":15,"(":16,"int":17,")":18,"]":19,"dstring":20,"sstring":21,"COMPARACION":22,"ASIGNACION":23,"INIT":24,"HEADER":25,"CONTENIDO":26,"EOF":27,"IMPORTS":28,"VARDEC":29,"#":30,".":31,"double":32,"TEMPDEC":33,";":34,",":35,"FUNCION":36,"void":37,"{":38,"CONTFUNC":39,"}":40,"ETIQUETA":41,"ETIQUETA2":42,"TEMPORAL":43,"IF":44,"return":45,"PRINTF":46,":":47,"goto":48,"CODMUERTO":49,"ETIQUETA3":50,"TEMPORAL2":51,"IF2":52,"if":53,"printf":54,"char":55,"$accept":0,"$end":1},
terminals_: {2:"error",4:"+",5:"-",6:"*",7:"/",8:"=",9:"!",10:"<",11:">",13:"id",14:"number",15:"[",16:"(",17:"int",18:")",19:"]",20:"dstring",21:"sstring",27:"EOF",30:"#",31:".",32:"double",34:";",35:",",37:"void",38:"{",40:"}",45:"return",47:":",48:"goto",53:"if",54:"printf",55:"char"},
productions_: [0,[3,1],[3,1],[3,1],[3,1],[3,2],[3,2],[3,1],[3,2],[3,1],[3,2],[12,1],[12,1],[12,2],[12,7],[12,4],[12,1],[12,1],[22,2],[22,2],[22,2],[22,2],[22,1],[22,1],[23,7],[23,4],[23,1],[24,3],[24,1],[25,2],[28,6],[28,8],[28,5],[28,7],[29,4],[29,3],[33,3],[33,6],[33,1],[33,4],[26,2],[26,1],[36,7],[39,2],[39,2],[39,2],[39,2],[39,3],[39,2],[39,5],[39,1],[39,1],[39,1],[39,2],[39,1],[39,4],[39,1],[43,6],[43,4],[41,2],[42,6],[42,5],[49,2],[49,2],[49,2],[49,3],[49,2],[49,5],[49,1],[49,1],[49,2],[49,1],[49,4],[49,1],[50,3],[51,6],[51,4],[44,9],[52,9],[46,10],[46,10]],
performAction: function anonymous(yytext, yyleng, yylineno, yy, yystate /* action[1] */, $$ /* vstack */, _$ /* lstack */) {
/* this == yyval */

var $0 = $$.length - 1;
switch (yystate) {
case 1: case 2: case 3: case 4: case 7: case 9: case 11: case 12: case 16: case 17: case 22: case 23: case 26:
this.$ = $$[$0]
break;
case 5: case 6: case 8: case 10: case 13: case 18: case 19: case 20: case 21:
this.$ = $$[$0-1]+$$[$0]
break;
case 14: case 24:
this.$ = $$[$0-6]+$$[$0-5]+$$[$0-4]+$$[$0-3]+$$[$0-2]+$$[$0-1]+$$[$0]
break;
case 15: case 25:
this.$ = $$[$0-3]+$$[$0-2]+$$[$0-1]+$$[$0]
break;
case 27:

        textoaux = texto;
        texto = "";
        Optim.GenerarGraphviz();
        textrep = Optim.textGraphviz;
        Optim.Reset();
        return {Optimizado: textoaux, TextGraphviz: textrep};
    
break;
case 30: case 32:
texto += "#" + $$[$0-3] + " <" + $$[$0-1] + ">\n";
break;
case 31: case 33:
texto += "#" + $$[$0-5] + " <" + $$[$0-3] + "." + $$[$0-1] + ">\n";
break;
case 34:

        texto += "double ";
        for(const key in $$[$0-1]) {
            texto += $$[$0-1][key];
        }
        texto += ";\n";
    
break;
case 35:

        texto += "\ndouble ";
        for(const key in $$[$0-1]) {
            texto += $$[$0-1][key];
        }
        texto += ";\n";
    
break;
case 36:
$$[$0-2].push(", "+$$[$0]);this.$=$$[$0-2];
break;
case 37:
$$[$0-5].push(", "+$$[$0-3]+"["+$$[$0-1]+"]");this.$=$$[$0-5];
break;
case 38:
this.$=[$$[$0]]
break;
case 39:
this.$=[$$[$0-3]+"["+$$[$0-1]+"]"];
break;
case 42:

        texto += "\n"+$$[$0-6]+" "+$$[$0-5]+$$[$0-4]+$$[$0-3]+" "+$$[$0-2]+"\n";
        for (const key in $$[$0-1]) {
            texto += $$[$0-1][key];
        }
        texto += $$[$0]+"\n";
    
break;
case 43: case 44: case 45: case 46: case 48: case 62: case 63: case 64: case 66:
$$[$0-1].push($$[$0]);this.$=$$[$0-1];
break;
case 47: case 65:
$$[$0-2].push($$[$0-1]+$$[$0]+"\n");this.$=$$[$0-2];
break;
case 49: case 67:
$$[$0-4].push($$[$0-3]+"();\n");this.$=$$[$0-4];
break;
case 50: case 51: case 52: case 54: case 56: case 68: case 69: case 71: case 73:
this.$ = [$$[$0]];
break;
case 53: case 70:
this.$=[$$[$0-1]+$$[$0]+"\n"];
break;
case 55: case 72:
this.$=[$$[$0-3]+"();\n"];
break;
case 57:

        this.$ = Optim.Optimizar(new Asignacion($$[$0-5],$$[$0-3],$$[$0-2],$$[$0-1]));
    
break;
case 58: case 76:
this.$=$$[$0-3]+" "+$$[$0-2]+" "+$$[$0-1]+$$[$0]+"\n";
break;
case 59:
this.$=$$[$0-1]+$$[$0]+"\n";
break;
case 60:

        this.$=$$[$0-5]+" "+$$[$0-4]+$$[$0-3]+"\n"+$$[$0-1]+$$[$0]+"\n";
        for (const key in $$[$0-2]) {
            texto += Optim.Optimizar($$[$0-2][key]);
        }
    
break;
case 61:
this.$=$$[$0-4]+" "+$$[$0-3]+$$[$0-2]+"\n"+$$[$0-1]+$$[$0]+"\n";
break;
case 74:
this.$=$$[$0-2]+" "+$$[$0-1]+$$[$0]+"\n";
break;
case 75:
this.$=$$[$0-5]+" "+$$[$0-4]+" "+$$[$0-3]+" "+$$[$0-2]+" "+$$[$0-1]+$$[$0]+"\n";
break;
case 77:
this.$= Optim.Optimizar(new Condicional($$[$0-6],$$[$0-5],$$[$0-4],$$[$0-2]+" "+$$[$0-1]+$$[$0]));
break;
case 78:
this.$=$$[$0-8]+$$[$0-7]+$$[$0-6]+$$[$0-5]+$$[$0-4]+$$[$0-3]+" "+$$[$0-2]+" "+$$[$0-1]+$$[$0]+"\n";
break;
case 79: case 80:
this.$=$$[$0-9]+$$[$0-8]+$$[$0-7]+$$[$0-6]+" "+$$[$0-5]+$$[$0-4]+$$[$0-3]+$$[$0-2]+$$[$0-1]+$$[$0]+"\n";
break;
}
},
table: [{24:1,25:2,27:[1,3],28:4,30:[1,5]},{1:[3]},{26:6,36:7,37:$V0},{1:[2,28]},{29:9,30:[1,10],32:[1,11]},{13:[1,12]},{27:[1,13],36:14,37:$V0},o($V1,[2,41]),{13:[1,15]},{32:[1,16],37:[2,29]},{13:[1,17]},{13:$V2,33:18},{10:[1,20]},{1:[2,27]},o($V1,[2,40]),{16:[1,21]},{13:$V2,33:22},{10:[1,23]},{34:[1,24],35:$V3},o($V4,[2,38],{15:[1,26]}),{13:[1,27]},{18:[1,28]},{34:[1,29],35:$V3},{13:[1,30]},o($V5,[2,35]),{13:[1,31]},{14:[1,32]},{11:[1,33],31:[1,34]},{38:[1,35]},o($V5,[2,34]),{11:[1,36],31:[1,37]},o($V4,[2,36],{15:[1,38]}),{19:[1,39]},o($V6,[2,32]),{13:[1,40]},{13:[1,47],23:49,39:41,41:42,42:48,43:43,44:44,45:[1,45],46:46,48:$V7,53:$V8,54:$V9},o($V6,[2,30]),{13:[1,53]},{14:[1,54]},o($V4,[2,39]),{11:[1,55]},{13:[1,63],23:49,40:[1,56],41:57,42:58,43:59,44:60,45:[1,61],46:62,48:$V7,53:$V8,54:$V9},o($Va,[2,50]),o($Va,[2,51]),o($Va,[2,52]),{34:[1,64]},o($Va,[2,54]),{8:$Vb,15:$Vc,16:[1,65],47:$Vd},o($Va,[2,56]),{8:[1,68]},{16:[1,69]},{16:[1,70]},{13:[1,71]},{11:[1,72]},{19:[1,73]},o($V6,[2,33]),o($V1,[2,42]),o($Va,[2,43]),o($Va,[2,44]),o($Va,[2,45]),o($Va,[2,46]),{34:[1,74]},o($Va,[2,48]),{8:$Vb,15:$Vc,16:[1,75],47:$Vd},o($Va,[2,53]),{18:[1,76]},o($Va,[2,59]),{5:$Ve,12:78,13:$Vf,14:$Vg,16:[1,77],20:$Vh,21:$Vi},{5:$Ve,12:84,13:$Vf,14:$Vg,20:$Vh,21:$Vi},{5:$Ve,12:85,13:$Vf,14:$Vg,20:$Vh,21:$Vi},{20:[1,86],21:[1,87]},{34:[1,88]},o($V6,[2,31]),o($V4,[2,37]),o($Va,[2,47]),{18:[1,89]},{34:[1,90]},{17:[1,91]},{19:[1,92]},o($Vj,[2,11],{15:[1,93]}),o($Vj,[2,12]),{14:[1,94]},o($Vj,[2,16]),o($Vj,[2,17]),{3:95,4:$Vk,5:$Vl,6:$Vm,7:$Vn,8:$Vo,9:$Vp,10:$Vq,11:$Vr,34:[1,96]},{8:$Vs,9:$Vt,10:$Vu,11:$Vv,22:105},{35:[1,110]},{35:[1,111]},{13:[1,113],23:119,45:[1,116],46:117,48:$Vw,49:112,50:118,51:114,52:115,53:$Vx,54:$V9},{34:[1,122]},o($Va,[2,55]),{18:[1,123]},{8:[2,25]},{5:$Ve,12:125,13:$Vf,14:$Vg,16:[1,124],20:$Vh,21:$Vi},o($Vj,[2,13]),{5:$Ve,12:126,13:$Vf,14:$Vg,20:$Vh,21:$Vi},o($Va,[2,58]),o($Vy,[2,1]),o($Vy,[2,2]),o($Vy,[2,3]),o($Vy,[2,4]),{8:[1,127]},{8:[1,128]},o($Vy,[2,7],{8:[1,129]}),o($Vy,[2,9],{8:[1,130]}),{5:$Ve,12:131,13:$Vf,14:$Vg,20:$Vh,21:$Vi},{8:[1,132]},{8:[1,133]},o($Vy,[2,23],{8:[1,134]}),o($Vy,[2,22],{8:[1,135]}),{16:[1,136]},{16:[1,137]},{13:[1,138],23:119,45:[1,142],46:143,48:$Vw,50:139,51:140,52:141,53:$Vx,54:$V9},{8:$Vb,15:$Vc,16:[1,145],47:[1,144]},o($Vz,[2,68]),o($Vz,[2,69]),{34:[1,146]},o($Vz,[2,71]),o($Vz,[2,73]),{8:[1,147]},{16:[1,148]},{13:[1,149]},o($Va,[2,49]),{5:$Ve,12:150,13:$Vf,14:$Vg,20:$Vh,21:$Vi},{17:[1,151]},{19:[1,152]},{34:[1,153]},o($Vy,[2,5]),o($Vy,[2,6]),o($Vy,[2,8]),o($Vy,[2,10]),{18:[1,154]},o($Vy,[2,18]),o($Vy,[2,19]),o($Vy,[2,20]),o($Vy,[2,21]),{55:[1,155]},{55:[1,156]},{8:$Vb,15:$Vc,16:[1,158],47:[1,157]},o($Vz,[2,62]),o($Vz,[2,63]),o($Vz,[2,64]),{34:[1,159]},o($Vz,[2,66]),o($Va,[2,61]),{18:[1,160]},o($Vz,[2,70]),{5:$Ve,12:161,13:$Vf,14:$Vg,20:$Vh,21:$Vi},{5:$Ve,12:162,13:$Vf,14:$Vg,20:$Vh,21:$Vi},{34:[1,163]},{19:[1,164]},{18:[1,165]},o($Vj,[2,15]),o($Va,[2,57]),{48:[1,166]},{18:[1,167]},{18:[1,168]},o($Va,[2,60]),{18:[1,169]},o($Vz,[2,65]),{34:[1,170]},{3:171,4:$Vk,5:$Vl,6:$Vm,7:$Vn,8:$Vo,9:$Vp,10:$Vq,11:$Vr,34:[1,172]},{8:$Vs,9:$Vt,10:$Vu,11:$Vv,22:173},o($Vz,[2,74]),{8:[2,24]},{5:$Ve,12:174,13:$Vf,14:$Vg,20:$Vh,21:$Vi},{13:[1,175]},{5:$Ve,12:176,13:$Vf,14:$Vg,20:$Vh,21:$Vi},{5:$Ve,12:177,13:$Vf,14:$Vg,20:$Vh,21:$Vi},{34:[1,178]},o($Vz,[2,72]),{5:$Ve,12:179,13:$Vf,14:$Vg,20:$Vh,21:$Vi},o($Vz,[2,76]),{5:$Ve,12:180,13:$Vf,14:$Vg,20:$Vh,21:$Vi},{19:[1,181]},{34:[1,182]},{18:[1,183]},{18:[1,184]},o($Vz,[2,67]),{34:[1,185]},{18:[1,186]},o($Vj,[2,14]),o($Va,[2,77]),{34:[1,187]},{34:[1,188]},o($Vz,[2,75]),{48:[1,189]},o($Va,[2,79]),o($Va,[2,80]),{13:[1,190]},{34:[1,191]},o($Vz,[2,78])],
defaultActions: {3:[2,28],13:[2,27],92:[2,25],164:[2,24]},
parseError: function parseError (str, hash) {
    if (hash.recoverable) {
        this.trace(str);
    } else {
        var error = new Error(str);
        error.hash = hash;
        throw error;
    }
},
parse: function parse(input) {
    var self = this, stack = [0], tstack = [], vstack = [null], lstack = [], table = this.table, yytext = '', yylineno = 0, yyleng = 0, recovering = 0, TERROR = 2, EOF = 1;
    var args = lstack.slice.call(arguments, 1);
    var lexer = Object.create(this.lexer);
    var sharedState = { yy: {} };
    for (var k in this.yy) {
        if (Object.prototype.hasOwnProperty.call(this.yy, k)) {
            sharedState.yy[k] = this.yy[k];
        }
    }
    lexer.setInput(input, sharedState.yy);
    sharedState.yy.lexer = lexer;
    sharedState.yy.parser = this;
    if (typeof lexer.yylloc == 'undefined') {
        lexer.yylloc = {};
    }
    var yyloc = lexer.yylloc;
    lstack.push(yyloc);
    var ranges = lexer.options && lexer.options.ranges;
    if (typeof sharedState.yy.parseError === 'function') {
        this.parseError = sharedState.yy.parseError;
    } else {
        this.parseError = Object.getPrototypeOf(this).parseError;
    }
    function popStack(n) {
        stack.length = stack.length - 2 * n;
        vstack.length = vstack.length - n;
        lstack.length = lstack.length - n;
    }
    _token_stack:
        var lex = function () {
            var token;
            token = lexer.lex() || EOF;
            if (typeof token !== 'number') {
                token = self.symbols_[token] || token;
            }
            return token;
        };
    var symbol, preErrorSymbol, state, action, a, r, yyval = {}, p, len, newState, expected;
    while (true) {
        state = stack[stack.length - 1];
        if (this.defaultActions[state]) {
            action = this.defaultActions[state];
        } else {
            if (symbol === null || typeof symbol == 'undefined') {
                symbol = lex();
            }
            action = table[state] && table[state][symbol];
        }
                    if (typeof action === 'undefined' || !action.length || !action[0]) {
                var errStr = '';
                expected = [];
                for (p in table[state]) {
                    if (this.terminals_[p] && p > TERROR) {
                        expected.push('\'' + this.terminals_[p] + '\'');
                    }
                }
                if (lexer.showPosition) {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ':\n' + lexer.showPosition() + '\nExpecting ' + expected.join(', ') + ', got \'' + (this.terminals_[symbol] || symbol) + '\'';
                } else {
                    errStr = 'Parse error on line ' + (yylineno + 1) + ': Unexpected ' + (symbol == EOF ? 'end of input' : '\'' + (this.terminals_[symbol] || symbol) + '\'');
                }
                this.parseError(errStr, {
                    text: lexer.match,
                    token: this.terminals_[symbol] || symbol,
                    line: lexer.yylineno,
                    loc: yyloc,
                    expected: expected
                });
            }
        if (action[0] instanceof Array && action.length > 1) {
            throw new Error('Parse Error: multiple actions possible at state: ' + state + ', token: ' + symbol);
        }
        switch (action[0]) {
        case 1:
            stack.push(symbol);
            vstack.push(lexer.yytext);
            lstack.push(lexer.yylloc);
            stack.push(action[1]);
            symbol = null;
            if (!preErrorSymbol) {
                yyleng = lexer.yyleng;
                yytext = lexer.yytext;
                yylineno = lexer.yylineno;
                yyloc = lexer.yylloc;
                if (recovering > 0) {
                    recovering--;
                }
            } else {
                symbol = preErrorSymbol;
                preErrorSymbol = null;
            }
            break;
        case 2:
            len = this.productions_[action[1]][1];
            yyval.$ = vstack[vstack.length - len];
            yyval._$ = {
                first_line: lstack[lstack.length - (len || 1)].first_line,
                last_line: lstack[lstack.length - 1].last_line,
                first_column: lstack[lstack.length - (len || 1)].first_column,
                last_column: lstack[lstack.length - 1].last_column
            };
            if (ranges) {
                yyval._$.range = [
                    lstack[lstack.length - (len || 1)].range[0],
                    lstack[lstack.length - 1].range[1]
                ];
            }
            r = this.performAction.apply(yyval, [
                yytext,
                yyleng,
                yylineno,
                sharedState.yy,
                action[1],
                vstack,
                lstack
            ].concat(args));
            if (typeof r !== 'undefined') {
                return r;
            }
            if (len) {
                stack = stack.slice(0, -1 * len * 2);
                vstack = vstack.slice(0, -1 * len);
                lstack = lstack.slice(0, -1 * len);
            }
            stack.push(this.productions_[action[1]][0]);
            vstack.push(yyval.$);
            lstack.push(yyval._$);
            newState = table[stack[stack.length - 2]][stack[stack.length - 1]];
            stack.push(newState);
            break;
        case 3:
            return true;
        }
    }
    return true;
}};

    const {Asignacion} = require("../Optimizador/Asignacion");
    const {Condicional} = require("../Optimizador/Condicional");
    const {OptimizadorMirilla} = require("../Optimizador/OptimizadorMirilla");
    var texto = "";
    var textoaux = "";
    var Optim = new OptimizadorMirilla();
    var textrep = "";
/* generated by jison-lex 0.3.4 */
var lexer = (function(){
var lexer = ({

EOF:1,

parseError:function parseError(str, hash) {
        if (this.yy.parser) {
            this.yy.parser.parseError(str, hash);
        } else {
            throw new Error(str);
        }
    },

// resets the lexer, sets new input
setInput:function (input, yy) {
        this.yy = yy || this.yy || {};
        this._input = input;
        this._more = this._backtrack = this.done = false;
        this.yylineno = this.yyleng = 0;
        this.yytext = this.matched = this.match = '';
        this.conditionStack = ['INITIAL'];
        this.yylloc = {
            first_line: 1,
            first_column: 0,
            last_line: 1,
            last_column: 0
        };
        if (this.options.ranges) {
            this.yylloc.range = [0,0];
        }
        this.offset = 0;
        return this;
    },

// consumes and returns one char from the input
input:function () {
        var ch = this._input[0];
        this.yytext += ch;
        this.yyleng++;
        this.offset++;
        this.match += ch;
        this.matched += ch;
        var lines = ch.match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno++;
            this.yylloc.last_line++;
        } else {
            this.yylloc.last_column++;
        }
        if (this.options.ranges) {
            this.yylloc.range[1]++;
        }

        this._input = this._input.slice(1);
        return ch;
    },

// unshifts one char (or a string) into the input
unput:function (ch) {
        var len = ch.length;
        var lines = ch.split(/(?:\r\n?|\n)/g);

        this._input = ch + this._input;
        this.yytext = this.yytext.substr(0, this.yytext.length - len);
        //this.yyleng -= len;
        this.offset -= len;
        var oldLines = this.match.split(/(?:\r\n?|\n)/g);
        this.match = this.match.substr(0, this.match.length - 1);
        this.matched = this.matched.substr(0, this.matched.length - 1);

        if (lines.length - 1) {
            this.yylineno -= lines.length - 1;
        }
        var r = this.yylloc.range;

        this.yylloc = {
            first_line: this.yylloc.first_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.first_column,
            last_column: lines ?
                (lines.length === oldLines.length ? this.yylloc.first_column : 0)
                 + oldLines[oldLines.length - lines.length].length - lines[0].length :
              this.yylloc.first_column - len
        };

        if (this.options.ranges) {
            this.yylloc.range = [r[0], r[0] + this.yyleng - len];
        }
        this.yyleng = this.yytext.length;
        return this;
    },

// When called from action, caches matched text and appends it on next action
more:function () {
        this._more = true;
        return this;
    },

// When called from action, signals the lexer that this rule fails to match the input, so the next matching rule (regex) should be tested instead.
reject:function () {
        if (this.options.backtrack_lexer) {
            this._backtrack = true;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });

        }
        return this;
    },

// retain first n characters of the match
less:function (n) {
        this.unput(this.match.slice(n));
    },

// displays already matched input, i.e. for error messages
pastInput:function () {
        var past = this.matched.substr(0, this.matched.length - this.match.length);
        return (past.length > 20 ? '...':'') + past.substr(-20).replace(/\n/g, "");
    },

// displays upcoming input, i.e. for error messages
upcomingInput:function () {
        var next = this.match;
        if (next.length < 20) {
            next += this._input.substr(0, 20-next.length);
        }
        return (next.substr(0,20) + (next.length > 20 ? '...' : '')).replace(/\n/g, "");
    },

// displays the character position where the lexing error occurred, i.e. for error messages
showPosition:function () {
        var pre = this.pastInput();
        var c = new Array(pre.length + 1).join("-");
        return pre + this.upcomingInput() + "\n" + c + "^";
    },

// test the lexed token: return FALSE when not a match, otherwise return token
test_match:function(match, indexed_rule) {
        var token,
            lines,
            backup;

        if (this.options.backtrack_lexer) {
            // save context
            backup = {
                yylineno: this.yylineno,
                yylloc: {
                    first_line: this.yylloc.first_line,
                    last_line: this.last_line,
                    first_column: this.yylloc.first_column,
                    last_column: this.yylloc.last_column
                },
                yytext: this.yytext,
                match: this.match,
                matches: this.matches,
                matched: this.matched,
                yyleng: this.yyleng,
                offset: this.offset,
                _more: this._more,
                _input: this._input,
                yy: this.yy,
                conditionStack: this.conditionStack.slice(0),
                done: this.done
            };
            if (this.options.ranges) {
                backup.yylloc.range = this.yylloc.range.slice(0);
            }
        }

        lines = match[0].match(/(?:\r\n?|\n).*/g);
        if (lines) {
            this.yylineno += lines.length;
        }
        this.yylloc = {
            first_line: this.yylloc.last_line,
            last_line: this.yylineno + 1,
            first_column: this.yylloc.last_column,
            last_column: lines ?
                         lines[lines.length - 1].length - lines[lines.length - 1].match(/\r?\n?/)[0].length :
                         this.yylloc.last_column + match[0].length
        };
        this.yytext += match[0];
        this.match += match[0];
        this.matches = match;
        this.yyleng = this.yytext.length;
        if (this.options.ranges) {
            this.yylloc.range = [this.offset, this.offset += this.yyleng];
        }
        this._more = false;
        this._backtrack = false;
        this._input = this._input.slice(match[0].length);
        this.matched += match[0];
        token = this.performAction.call(this, this.yy, this, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
        if (this.done && this._input) {
            this.done = false;
        }
        if (token) {
            return token;
        } else if (this._backtrack) {
            // recover context
            for (var k in backup) {
                this[k] = backup[k];
            }
            return false; // rule action called reject() implying the next rule should be tested instead.
        }
        return false;
    },

// return next match in input
next:function () {
        if (this.done) {
            return this.EOF;
        }
        if (!this._input) {
            this.done = true;
        }

        var token,
            match,
            tempMatch,
            index;
        if (!this._more) {
            this.yytext = '';
            this.match = '';
        }
        var rules = this._currentRules();
        for (var i = 0; i < rules.length; i++) {
            tempMatch = this._input.match(this.rules[rules[i]]);
            if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                match = tempMatch;
                index = i;
                if (this.options.backtrack_lexer) {
                    token = this.test_match(tempMatch, rules[i]);
                    if (token !== false) {
                        return token;
                    } else if (this._backtrack) {
                        match = false;
                        continue; // rule action called reject() implying a rule MISmatch.
                    } else {
                        // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                        return false;
                    }
                } else if (!this.options.flex) {
                    break;
                }
            }
        }
        if (match) {
            token = this.test_match(match, rules[index]);
            if (token !== false) {
                return token;
            }
            // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
            return false;
        }
        if (this._input === "") {
            return this.EOF;
        } else {
            return this.parseError('Lexical error on line ' + (this.yylineno + 1) + '. Unrecognized text.\n' + this.showPosition(), {
                text: "",
                token: null,
                line: this.yylineno
            });
        }
    },

// return next match that has a token
lex:function lex () {
        var r = this.next();
        if (r) {
            return r;
        } else {
            return this.lex();
        }
    },

// activates a new lexer condition state (pushes the new lexer condition state onto the condition stack)
begin:function begin (condition) {
        this.conditionStack.push(condition);
    },

// pop the previously active lexer condition state off the condition stack
popState:function popState () {
        var n = this.conditionStack.length - 1;
        if (n > 0) {
            return this.conditionStack.pop();
        } else {
            return this.conditionStack[0];
        }
    },

// produce the lexer rule set which is active for the currently active lexer condition state
_currentRules:function _currentRules () {
        if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) {
            return this.conditions[this.conditionStack[this.conditionStack.length - 1]].rules;
        } else {
            return this.conditions["INITIAL"].rules;
        }
    },

// return the currently active lexer condition state; when an index argument is provided it produces the N-th previous condition state, if available
topState:function topState (n) {
        n = this.conditionStack.length - 1 - Math.abs(n || 0);
        if (n >= 0) {
            return this.conditionStack[n];
        } else {
            return "INITIAL";
        }
    },

// alias for begin(condition)
pushState:function pushState (condition) {
        this.begin(condition);
    },

// return the number of states currently on the stack
stateStackSize:function stateStackSize() {
        return this.conditionStack.length;
    },
options: {"case-insensitive":true},
performAction: function anonymous(yy,yy_,$avoiding_name_collisions,YY_START) {
var YYSTATE=YY_START;
switch($avoiding_name_collisions) {
case 0:/*skip single line comments*/
break;
case 1:/*skip whitespace*/
break;
case 2:/*skip multi line comments*/
break;
case 3:return 47;
break;
case 4:return 8;
break;
case 5:return 4;
break;
case 6:return 5;
break;
case 7:return 6;
break;
case 8:return 7;
break;
case 9:return 34;
break;
case 10:return 30;
break;
case 11:return 10;
break;
case 12:return 11;
break;
case 13:return 31;
break;
case 14:return 15;
break;
case 15:return 19;
break;
case 16:return 35;
break;
case 17:return 16;
break;
case 18:return 18;
break;
case 19:return 38;
break;
case 20:return 40;
break;
case 21:return 9;
break;
case 22:return '%';
break;
case 23:return 32;
break;
case 24:return 37;
break;
case 25:return 45;
break;
case 26:return 17;
break;
case 27:return 53;
break;
case 28:return 48;
break;
case 29:return 54;
break;
case 30:return 55;
break;
case 31:return 20;
break;
case 32:return 21;
break;
case 33:return 13;
break;
case 34:return 14;
break;
case 35:return 'random';
break;
case 36:return 27;
break;
case 37:
                                        console.log('Este es un error léxico: ' + yy_.yytext + ', en la linea: ' + yy_.yylloc.first_line + ', en la columna: ' + yy_.yylloc.first_column);
                                    
break;
}
},
rules: [/^(?:[/][/][^\n]*)/i,/^(?:\s+)/i,/^(?:[/][*][^*]*[*]+([^/*][^*]*[*]+)*[/])/i,/^(?::)/i,/^(?:=)/i,/^(?:\+)/i,/^(?:-)/i,/^(?:\*)/i,/^(?:\/)/i,/^(?:;)/i,/^(?:#)/i,/^(?:<)/i,/^(?:>)/i,/^(?:\.)/i,/^(?:\[)/i,/^(?:\])/i,/^(?:,)/i,/^(?:\()/i,/^(?:\))/i,/^(?:\{)/i,/^(?:\})/i,/^(?:!)/i,/^(?:%)/i,/^(?:double\b)/i,/^(?:void\b)/i,/^(?:return\b)/i,/^(?:int\b)/i,/^(?:if\b)/i,/^(?:goto\b)/i,/^(?:printf\b)/i,/^(?:char\b)/i,/^(?:("([^\"\\])*"))/i,/^(?:('([^\'\\])*'))/i,/^(?:([a-zA-Z_]|á|é|í|ó|ú|Á|É|Í|Ó|Ú)(-|[a-zA-Z0-9_ñÑ]|á|é|í|ó|ú|Á|É|Í|Ó|Ú|')*)/i,/^(?:(([0-9]+\.[0-9]+)|(\.[0-9]+)|([0-9]+)))/i,/^(?:[^<> ]+)/i,/^(?:$)/i,/^(?:.)/i],
conditions: {"INITIAL":{"rules":[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37],"inclusive":true}}
});
return lexer;
})();
parser.lexer = lexer;
function Parser () {
  this.yy = {};
}
Parser.prototype = parser;parser.Parser = Parser;
return new Parser;
})();


if (typeof require !== 'undefined' && typeof exports !== 'undefined') {
exports.parser = c3dgrammar;
exports.Parser = c3dgrammar.Parser;
exports.parse = function () { return c3dgrammar.parse.apply(c3dgrammar, arguments); };
exports.main = function commonjsMain (args) {
    if (!args[1]) {
        console.log('Usage: '+args[0]+' FILE');
        process.exit(1);
    }
    var source = require('fs').readFileSync(require('path').normalize(args[1]), "utf8");
    return exports.parser.parse(source);
};
if (typeof module !== 'undefined' && require.main === module) {
  exports.main(process.argv.slice(1));
}
}